module.exports = {"firebase":{"apiKey":"AIzaSyAmYYQyvIsH_4Zg1eR2yzK8gB-R2mE56-k","authDomain":"trunk-cms.firebaseapp.com","databaseURL":"https://trunk-cms.firebaseio.com","projectId":"trunk-cms","storageBucket":"trunk-cms.appspot.com","messagingSenderId":"683993747789"},"google":{"apiKey":"AIzaSyCpsXxCdiUSILSFE_l5lJ13mZf3cC1mdnM"}}


//////////////////
// WEBPACK FOOTER
// ./config/app.json
// module id = 96
// module chunks = 8